// In a tracking file (analytics.js)
import ReactGA from 'react-ga4';
ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANAYLITICS);
export default ReactGA;
